import { FlexBox, Text } from '@dixa/lib-shared-habla';

import { MessageAuditLogEntry } from 'apis/auditLogs';
import { ConversationTimestamp } from 'components/conversation/components/conversationTimestamp/conversationTimestamp';

import { getLogEntryAuthorName, hasLogEntryAuthor } from './logEntry';
import { UserLink } from './userLink/userLink';

type MessageActivityProps = {
  entry: MessageAuditLogEntry;
};

function getMessageActivityText(entry: MessageAuditLogEntry): string {
  switch (entry.activity_type) {
    case 'MESSAGE_ADDED':
      return 'Message added';
    case 'MESSAGE_SENT':
      return 'Accepted for delivery';
    case 'MESSAGE_DELIVERED':
      return 'Delivered';
    case 'MESSAGE_SEEN':
      return 'Seen';
    case 'MESSAGE_DELIVERY_INFO':
      return 'Delivery update';
    case 'MESSAGE_SPAM_COMPLAINT':
      return 'Marked as spam';
    case 'MESSAGE_DELIVERY_FAILED':
      return 'Failed to send';
    case 'MESSAGE_DELIVERY_RETRIED':
      return `Sending retried (attempt ${entry.attempt})`;
    default:
      return 'Unrecognized activity';
  }
}

export const MessageActivity = ({
  entry,
}: MessageActivityProps): JSX.Element => {
  const text = getMessageActivityText(entry);
  const info = 'info' in entry ? entry.info : undefined;
  // Channels can report just the status itself, e.g. "delivered".
  const showInfo = info
    ? info.trim().toLowerCase() !== text.trim().toLowerCase()
    : false;

  return (
    <FlexBox alignItems="center" gap="200">
      <FlexBox flexDirection="column" flex="1">
        <Text.Paragraph variant="2" subdued>
          {text}
          {hasLogEntryAuthor(entry) && (
            <>
              {' by '}
              <UserLink userId={entry.author.id}>
                {getLogEntryAuthorName(entry)}
              </UserLink>
            </>
          )}
        </Text.Paragraph>
        {showInfo && (
          <Text.Paragraph variant="4" subdued>
            {info}
          </Text.Paragraph>
        )}
      </FlexBox>
      <ConversationTimestamp
        shouldDateFormatPersist={true}
        time={entry.event_timestamp}
        isSecondsDisplayed={false}
      />
    </FlexBox>
  );
};
